var WebFont = require('webfontloader');

export default {
  init: function () {
    WebFont.load({
      // typekit: {
      //   id: 'drs7afh',
      // },
      // google: {
      //   families: ['Poppins:400,500,600,700,800'],
      // },
      // custom: {
      //   families: ['Arquitecta:n3,n5', 'Silk Serif'],
      // },
    });
  },
};
